import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { useStore } from 'models/stores';

import JobHeader from './JobHeader';

import { ARTICLE_MAX_WIDTH, CONTENT_MAX_WIDTH } from '../styles/constants';

function Job({ data }) {
  const { uiStore } = useStore();

  const languageData = data.languages.find((l) => l.language === uiStore.language);
  const shortDescription = languageData.shortDescriptionHtml || data.shortDescription;

  return (
    <JobEntryContainer onMouseEnter={data.load}>
      <JobEntry>
        <JobHeader job={data} langData={languageData} />
        <JobShortDescription dangerouslySetInnerHTML={{ __html: shortDescription }} />
      </JobEntry>
    </JobEntryContainer>
  );
}

export default observer(Job);

const JobEntryContainer = styled.div`
  overflow-wrap: break-word;
  box-sizing: border-box;
  position: relative;
  background-color: ${(p) => p.theme.white};
  color: ${(p) => p.theme.textColor};
  width: 100%;
  display: flex;
  align-items: center;
  @media (max-width: 1080px) {
    padding: 0px 24px;
  }

  :hover {
    cursor: pointer;
    background-color: ${(p) => p.theme.listBgHoverColor};

    > div {
      > h2 {
        color: ${(p) => p.theme.headingHoverColor};
      }
    }
  }
`;

const JobEntry = styled.div`
  padding: 40px 0;
  margin: 0 auto;
  width: 100%;
  max-width: ${CONTENT_MAX_WIDTH};
  > * {
    max-width: ${ARTICLE_MAX_WIDTH};
  }

  > h2 {
    font-size: 18px;
    color: ${(p) => p.theme.headingColor};
    font-weight: bold;
    margin: 0 0 0.2em 0;
    word-break: break-word;
  }
`;

const JobShortDescription = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 24px;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  p {
    margin: 0;
    padding: 0;
  }
  p:empty {
    padding: 8px 0;
  }
`;
